module.exports = __webpack_public_path__ + "static/what-technology-wants-e5339179a90fe72af83a2fd7181fb45f.jpg";